






























































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Axios from "../../plugins/http";
import moment from "../../plugins/moment";

@Component
export default class Index extends Vue {
  tableData: any[] = [];
  pageNo: number = 1;
  total: number = 1;
  size: number = 1;
  date: any[] = [];
  loading: boolean = false;
  showMore: boolean = false;

  search: any = {
    beginTime: null,
    endTime: null,
    buyerNickname: null,
    logisticsNumber: null,
    orderId: null,
    phoneNumber: null,
    skuCode: null,
    tab: "all", // ALL全部，UNDONE未完成，FINISH已完成，INTERCEPTED已拦截
  };
  tabTypes: any = {
    all: "全部",
    undone: "未完成",
    finish: "已完成",
    intercepted: "已拦截",
  };
  currentData: any = {};
  dialog: boolean = false;
  statesColor: any = {
    待补货: "warning",
    已拦截: "danger",
    已完成: "success",
  };
  $refs: any = {};
  formatDayTo: any = moment.formatDayTo;

  created() {
    this.getList();
  }

  changeSearch(type) {
    let orderId = null;
    if (type === "date") {
      if (this.date) {
        let [beginTime, endTime] = this.date;
        this.search.beginTime = beginTime;
        this.search.endTime = endTime;
      } else {
        this.search.beginTime = undefined;
        this.search.endTime = undefined;
      }
    }
    if (type === "orderId") {
      if (
        this.search.orderId.match(/@/g) &&
        this.search.orderId.match(/@/g).length >= 2
      ) {
        let splits = this.search.orderId.split(/@/g);
        orderId = splits[splits.length - 1];
      }
    }
  }

  handlePageChange(val) {
    this.pageNo = val;
    this.getList();
  }
  getList() {
    this.loading = true;
    let [beginTime, endTime] = this.date || [];
    Axios.getSecret(`/api/order/shop_order/page`, {
      pageNo: this.pageNo,
      beginTime,
      endTime,
      ...this.search,
    }).then(
      ({
        data: {
          data: { records, total, size },
          status,
          msg,
        },
      }) => {
        if (status === 200) {
          this.tableData = records;
          this.total = Number(total);
          this.size = Number(size);
        } else {
          this.$message(msg);
        }
        this.loading = false;
      }
    );
  }
  getDetail(data) {
    this.currentData = data;
    this.dialog = true;
  }

  getChildTimeLine(expandedRows) {
    // 存在timeLine直接返回，不进行操作
    if (expandedRows.timeLine) return;

    Axios.getSecret(`/api/order/sub_order/opLog/list`, {
      orderId: expandedRows.id,
      skuCode: expandedRows.skuCode,
    }).then(({ data: { data, status, msg } }) => {
      if (status === 200) {
        this.$set(expandedRows, "timeLine", data);
        setTimeout(() => {
          this.$refs.table.toggleRowExpansion(expandedRows);
        }, 100);
      } else {
        this.$message(msg);
      }
    });
  }

  toggleTimeLine(index) {
    this.$set(
      this.tableData[index],
      "timeLine",
      !this.tableData[index].timeLine
    );
  }
}
